<section>
  <div flex fxLayout="column" fxLayoutAlign="center">
    <strong>Empfänger</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.recipients }}
      <span *ngIf="comment">und {{ comment }}</span>
    </p>
    <strong>Betreff der E-Mail</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">
      {{ this.data.actionInfo.subject }}
    </p>
    <strong style="margin-bottom: 0.5rem">
      Sie können diese Netzanmeldung an einen anderen Benutzer des Installateurportales übertragen. Geben Sie
      uns dazu hier die E-Mail-Adresse des Benutzers an. Dieser erhält daraufhin eine E-Mail mit einem Link um
      die Netzanmeldung mit seinem Account zu verknüpfen.
    </strong>

    <p style="margin-bottom: 0.5rem">
      Bitte beachten Sie, dass sie danach keinen Zugriff mehr auf diesen Vorgang haben.
    </p>
  </div>
</section>

<form [formGroup]="currentForm">
  <section fxLayout="column" fxLayoutAlign=" start">
    <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlexAlign="stretch">
      <mat-label>E-Mail:</mat-label>
      <input matInput placeholder="E-Mail" formControlName="email" />
      <mat-error *ngIf="!currentForm.controls['email'].valid && currentForm.controls['email'].touched">
        {{ validatorsService.getErrorMail(currentForm, 'email') }}
      </mat-error>
    </mat-form-field>

    <div *ngIf="!eMailExists" class="alert alert-danger" fxFlexAlign="stretch">
      Für die von Ihnen angegebene E-Mail-Adresse haben wir keinen gültigen Benutzer gefunden.
    </div>

    <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlexAlign="stretch">
      <mat-label>Kommentar:</mat-label>
      <textarea
        matInput
        type="text"
        placeholder="Kommentar"
        rows="3"
        maxlength="255"
        formControlName="comment"></textarea>
    </mat-form-field>
  </section>
</form>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" id="modal-confirm-after-meter-change" (click)="confirm()">
    <span>Netzanmeldung übertragen</span>
  </button>
</div>
